import { z } from 'zod';

export const ShareEntityType = z.enum(['event', 'news', 'place', 'service', 'organizer', 'user']);
export type ShareEntityType = z.infer<typeof ShareEntityType>;

export const CreateShareInput = z
  .object({
    entityType: ShareEntityType,
    entityId: z.uuid(),
  })
  .strip();
export type CreateShareInput = z.infer<typeof CreateShareInput>;

export const ShareDto = z.object({
  shortCode: z.string(),
  slug: z.string().nullable(),
});
export type ShareDto = z.infer<typeof ShareDto>;

export const ResolvedShareDto = z.discriminatedUnion('entityType', [
  z.object({
    entityType: z.literal('event'),
    entityId: z.string(),
  }),
  z.object({
    entityType: z.literal('place'),
    entityId: z.string(),
  }),
  z.object({
    entityType: z.literal('service'),
    entityId: z.string(),
  }),
  z.object({
    entityType: z.literal('news'),
    entityId: z.string(),
    sourceUrl: z.url(),
  }),
  z.object({
    entityType: z.literal('organizer'),
    entityId: z.string(),
  }),
  z.object({
    entityType: z.literal('user'),
    entityId: z.string(),
  }),
]);
export type ResolvedShareDto = z.infer<typeof ResolvedShareDto>;

/** Rich-share через Bot API savePreparedInlineMessage (пока только event). */
export const CreatePreparedShareInput = z
  .object({
    entityType: z.literal('event'),
    entityId: z.uuid(),
  })
  .strip();
export type CreatePreparedShareInput = z.infer<typeof CreatePreparedShareInput>;

export const PreparedShareDto = z.object({
  preparedMessageId: z.string().min(1),
  /** Unix seconds — expiration_date из Telegram. */
  expiresAt: z.number().int(),
});
export type PreparedShareDto = z.infer<typeof PreparedShareDto>;
